import * as React from "react";

const SVGComponent = (props) => {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g transform="rotate(-45 12 12)">
        <path
          d="M3 12C6 9 9 6 12 9C15 12 18 15 21 12"
          stroke={props.color || "#4F4F4F"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default SVGComponent;
